import { Icon } from "@mdi/react";

import {
  mdiAccount,
  mdiDomain,
  mdiHomeLightbulb,
  mdiImageFilterHdr,
  mdiLandslide,
  mdiLayers,
  mdiMemory
} from "@mdi/js";
import classnames from "classnames";
import {
  ORG_GEO_FIELDS,
  ORG_GEO_SIMS,
  SHAPEFILE_FIELDS
} from "constants/settings.constants";
import styled from "styled-components";

import { IGroupByListItem } from "models";

interface CategoryListItemProps {
  readonly value: IGroupByListItem;
  readonly isSelected?: boolean;
  readonly active?: boolean;
  readonly itemRef?: (el: Maybe<HTMLElement>) => void;
  readonly onCategoryClick?: (category: IGroupByListItem) => void;
}

function CategoryListItem({
  value,
  isSelected = false,
  active = false,
  itemRef,
  onCategoryClick
}: CategoryListItemProps) {
  const { hexColor, name } = value;

  const changeCategory = () => {
    onCategoryClick?.(value);
  };

  const rootClassNames = classnames({
    selected: isSelected,
    "keyboard-focused": active
  });

  return (
    <Wrapper
      ref={itemRef}
      className={`${rootClassNames} category-list-item`}
      role="button"
      tabIndex={0}
      onClick={changeCategory}>
      <Swatch color={hexColor}>
        {hexColor === "#ccc" && <Icon path={mdiImageFilterHdr} size={1} />}
        {name === "Organization Fields" && <Icon path={mdiDomain} size={1} />}
        {name === ORG_GEO_FIELDS && <Icon path={mdiLandslide} size={1} />}
        {name === ORG_GEO_SIMS && <Icon path={mdiMemory} size={1} />}
        {name === "My Fields" && <Icon path={mdiAccount} size={1} />}
        {name === "Project Fields" && <Icon path={mdiHomeLightbulb} size={1} />}
        {name === SHAPEFILE_FIELDS && <Icon path={mdiLayers} size={1} />}
      </Swatch>
      <Label>{name}</Label>
    </Wrapper>
  );
}

export default CategoryListItem;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-2);
  color: rgba(var(--color-text-rgb), 0.6);
  border-radius: var(--border-radius);
  font-weight: var(--fontWeightMedium);
  padding: var(--space-1) var(--space-4);
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    color: var(--color-text);
    background-color: var(--color-accent-hover);
  }
  &:focus {
    outline: none; /* Remove default focus outline */
  }
  &.selected {
    color: var(--color-text);
    background-color: var(--color-accent-hover);
    font-weight: var(--fontWeightBold);
  }
`;

const Swatch = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background-color: ${(props) => props.color};
  border-radius: var(--space-05);
  color: #fff;
`;

const Label = styled.span`
  max-width: calc(100% - var(--space-4));
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
